
export default {
    namespaced: true,
    state: () => ({
        list: {
            initialized: false,
            values: []
        }
    }),
    mutations: {
        LOAD_CANDIDATOS(state, data) {
            state['list']['initialized'] = true;
            state['list']['values'] = data;
        },
        UPDATE_CANDIDATO(state, candidato) {
            //substituir o item da lista de forma reativa
            //basicamente recria o array, substituindo o antigo candidato pelo atualizado
            state.list.values = [...state.list.values.map(item => item.id !== candidato.id ? item : {...item, ...candidato})]
        },
    },
    getters: {
        list: state => {
            return state.list.values;
        },
    }
}